// removed by extract-text-webpack-plugin
module.exports = {"pitch":"#282c31","brand":"#2f75c1","recentViewMask":"RecentView__recentViewMask___3r133","recentView":"RecentView__recentView___15_hx","recentViewInner":"RecentView__recentViewInner___Z45CZ","closeRecent":"RecentView__closeRecent___10m6q","appear":"RecentView__appear___2D2sl","appearActive":"RecentView__appearActive___150JP"};


//////////////////
// WEBPACK FOOTER
// ./src/chat/components/styles/RecentView.css
// module id = 2203
// module chunks = 0 1